import React, { useState } from 'react';
import { Building2, MapPin, Shield, Database, FileCheck, X } from 'lucide-react';

const Facts = () => {
  const [isMapOpen, setIsMapOpen] = useState(false);
  const facts = [
    {
      icon: Building2,
      number: '2000',
      unit: 'm²',
      label: 'Modernaus sandėlio',
      color: 'blue'
    },
    {
      icon: MapPin,
      text: 'Strateginė vieta',
      label: 'Nemajūnų g. 19, Kaunas',
      color: 'green'
    },
    {
      icon: Shield,
      text: 'Saugumas',
      label: 'Aptverta teritorija ir signalizacija',
      color: 'red'
    },
    {
      icon: Database,
      text: 'WMS sistema',
      label: 'Sandėlio valdymo sistema',
      color: 'purple'
    },
    {
      icon: FileCheck,
      text: 'Draudimas',
      label: 'Atsargų draudimas',
      color: 'orange'
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-blue-600 to-blue-800 text-white" data-testid="facts-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Faktai, kuriais galite pasitikėti
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Mūsų infrastruktūra ir profesionalumas užtikrina jūsų verslo sėkmę
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {facts.map((fact, index) => {
            const Icon = fact.icon;
            const isMapCard = fact.text === 'Strateginė vieta';
            const Wrapper = isMapCard ? 'button' : 'div';
            return (
              <Wrapper
                key={index}
                type={isMapCard ? 'button' : undefined}
                onClick={isMapCard ? () => setIsMapOpen(true) : undefined}
                className={`bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 text-center hover:bg-white/20 transition-all ${
                  isMapCard ? 'cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70' : ''
                }`}
                data-testid={`fact-card-${index}`}
              >
                <div className="inline-flex items-center justify-center bg-white/20 p-3 rounded-full mb-4">
                  <Icon className="h-8 w-8 text-white" />
                </div>
                {fact.number ? (
                  <div className="mb-2">
                    <span className="text-4xl font-bold">{fact.number}</span>
                    <span className="text-2xl ml-1">{fact.unit}</span>
                  </div>
                ) : (
                  <h3 className="text-xl font-bold mb-2">{fact.text}</h3>
                )}
                <p className="text-blue-100 text-sm">{fact.label}</p>
              </Wrapper>
            );
          })}
        </div>
      </div>

      {isMapOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="map-modal">
          <div className="fixed inset-0 bg-black/60" onClick={() => setIsMapOpen(false)}></div>
          <div className="relative z-10 w-full max-w-4xl overflow-hidden rounded-2xl bg-white shadow-2xl">
            <button
              onClick={() => setIsMapOpen(false)}
              className="absolute right-4 top-4 rounded-full bg-white/90 p-2 text-gray-700 shadow hover:bg-white"
              aria-label="Uždaryti žemėlapį"
              type="button"
            >
              <X className="h-5 w-5" />
            </button>
            <div className="aspect-video w-full">
              <iframe
                title="WSK Logistika location"
                src="https://www.google.com/maps?q=Nemaj%C5%ABn%C5%B3%20g.%2019%2C%20LT-52459%20Kaunas&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Facts;
